import { createSlice } from "@reduxjs/toolkit";
import { stcoToolsReducer } from "./reducer";
import { initialState } from "./initialState";
import {
  addClientIdPasswordManagerAction,
  addGstRegisterBusinessAction,
  addIdPasswordManagerAction,
  applyLeaveOrWHFAction,
  deleteIdPasswordManagerAction,
  deleteUpcomingLeave,
  editClientIdPasswordManagerAction,
  editIdPasswordManagerAction,
  getClientIdPasswordManagerListAction,
  getIdPasswordManagerListAction,
  getLeaveAndWFHListAction,
  getSingleLeaveAction,
  getTokenGenerateForDownloadAction,
  getUpcomingListAction,
  isGstRegisteredVerifyAction,
  leaveAndWFHApprovedStatusAction,
  leaveAndWFHRejectStatusAction,
  updateApplyLeaveOrWHFAction,
  uploadFilesAction,
} from "./actions";
import { StcoToolsType } from "./stcoToolsType";

export const stcoToolsSlice = createSlice({
  name: "stcoTools",
  initialState,
  reducers: stcoToolsReducer,
  extraReducers: {
    [getIdPasswordManagerListAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getIdPasswordManagerListAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, result, status_code, count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
          getidPasswordManagerList: result,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        getidPasswordManagerList: result,
        totalUserCountList: count,
      };
    },
    [getIdPasswordManagerListAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [addIdPasswordManagerAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addIdPasswordManagerAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [addIdPasswordManagerAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [editIdPasswordManagerAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [editIdPasswordManagerAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [editIdPasswordManagerAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [deleteIdPasswordManagerAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteIdPasswordManagerAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [deleteIdPasswordManagerAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [getClientIdPasswordManagerListAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientIdPasswordManagerListAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, result, status_code, count } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
          getClientidPasswordManagerList: result,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        getClientidPasswordManagerList: result,
        totalClientList: count,
      };
    },
    [getClientIdPasswordManagerListAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [addClientIdPasswordManagerAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addClientIdPasswordManagerAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
      };
    },
    [addClientIdPasswordManagerAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [editClientIdPasswordManagerAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [editClientIdPasswordManagerAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
      };
    },
    [editClientIdPasswordManagerAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getLeaveAndWFHListAction.pending.toString()]: (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }),
    [getLeaveAndWFHListAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        count,
        total_count,
        leave_status,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
          leaveAndWFHHistoryList: result,
          leaveTotalCount: total_count,
          balanceLeave: leave_status,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        leaveAndWFHHistoryList: result,
        leaveTotalCount: total_count,
        balanceLeave: leave_status,
      };
    },
    [getLeaveAndWFHListAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getUpcomingListAction.pending.toString()]: (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }),
    [getUpcomingListAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        count,
        leave_status,
        wfh_status,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
          upcomingList: result,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        upcomingList: result,
        leaveStatus: leave_status,
        workFromHomeStatus: wfh_status,
      };
    },
    [getUpcomingListAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [applyLeaveOrWHFAction.pending.toString()]: (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }),
    [applyLeaveOrWHFAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [applyLeaveOrWHFAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [getSingleLeaveAction.pending.toString()]: (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }),
    [getSingleLeaveAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
          // singleLeaveAndWFHApplyData: result
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        singleLeaveAndWFHApplyData: result,
      };
    },
    [getSingleLeaveAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [updateApplyLeaveOrWHFAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateApplyLeaveOrWHFAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [updateApplyLeaveOrWHFAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [deleteUpcomingLeave.pending.toString()]: (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }),
    [deleteUpcomingLeave.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [deleteUpcomingLeave.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [leaveAndWFHRejectStatusAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [leaveAndWFHRejectStatusAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [leaveAndWFHRejectStatusAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [leaveAndWFHApprovedStatusAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [leaveAndWFHApprovedStatusAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [leaveAndWFHApprovedStatusAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [addGstRegisterBusinessAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addGstRegisterBusinessAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          gstRegisterSuccess: 0,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        gstRegisterSuccess: success,
        gstRegisterMessage: message,
      };
    },
    [addGstRegisterBusinessAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      gstRegisterSuccess: 0,
      error: error.message,
    }),

    [isGstRegisteredVerifyAction.pending.toString()]: (
      state: StcoToolsType
    ) => ({
      ...state,
      fetching: true,
    }),
    [isGstRegisteredVerifyAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        isGstRegisteredVerifyData: result,
      };
    },
    [isGstRegisteredVerifyAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    // file upload slice
   
    [uploadFilesAction.pending.toString()]: (state: StcoToolsType) => ({
      ...state,
      fileUploadFetching: true,
    }),
    [uploadFilesAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const { success, message, result, status_code,fileUploadSuccess,fileUploadMessage } = payload;
      if (success === 0) {
        return {
          ...state,
          fileUploadFetching: false,
          fileUploadError: message,
            statusCode: status_code,
            fileUploadData: payload.files,
            fileUploadSuccess,
        };
      }
      return {
        ...state,
        fileUploadFetching: false,
        fileUploadData: payload.files,
        fileUploadMessage,
        fileUploadSuccess,
      };
    },
    [uploadFilesAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      fileUploadFetching: false,
      fileUploadError: error?.message,
        fileUploadSuccess: 0,
    }),

    // download file
    [getTokenGenerateForDownloadAction.pending.toString()]: (state: StcoToolsType) => ({
      ...state,
      sasTokenForDownloadFetching: true,
    }),
    [getTokenGenerateForDownloadAction.fulfilled.toString()]: (
      state: StcoToolsType,
      { payload }
    ) => {
      const {
        result = {},
        message,
        status_code,
        success,
        file_url
      } = payload;
      if (success === 0) {
        return {
          ...state,
          sasTokenForDownloadFetching: false,
          error: message,
          success: 0,
          statusCode: status_code
        };
      }
      return {
        ...state,
        sasTokenForDownloadFetching: false,
        statusCode: status_code,
        sasTokenForDownloadFile: file_url,
      };
    },
    [getTokenGenerateForDownloadAction.rejected.toString()]: (
      state: StcoToolsType,
      { error }
    ) => ({
      ...state,
      sasTokenForDownloadFetching: false,
      success: 0,
      error: error.message,
    }),
  },
});

export const {
  resetIdPasswordManagerError,
  resetIdPasswordManagerSuccess,
  resetIdPasswordManagerList,
  resetIdPasswordManagerMessage,
  resetClientIdPasswordManagerList,
  resetIdPasswordManagerStatusCode,
  resetTotalUserCountList,
  resetTotalClientCountList,
  resetStcoToolsSuccess,
  resetStcoToolsError,
  resetStcoToolsMessage,
  resetStcoToolsStatusCode,
  resetUpcomingLeaveList,
  resetSingleLeaveAndWFHApplyData,
  resetLeaveAndWFHList,
  resetGstRegisterMessage,
  resetIsGstRegisteredVerifyData,
  resetGstRegisterSuccess,
  resetStcoToolsFetching,
  resetUploadedFiles,
  resetSasTokenForDownloadFile
} = stcoToolsSlice.actions;
